import React from 'react';

const LoadingSpinner = ({ size = 'medium', color = 'primary-pink' }) => {
    const sizeClasses = {
        small: 'w-6 h-6',
        medium: 'w-12 h-12',
        large: 'w-16 h-16'
    };

    const colorClasses = {
        'primary-pink': 'border-t-primary-pink border-b-primary-pink',
        'white': 'border-t-white border-b-white',
        'primary': 'border-t-primary-500 border-b-primary-500'
    };

    return (
        <div className="flex justify-center items-center">
            <div
                className={`
          ${sizeClasses[size]}
          ${colorClasses[color]}
          border-2 border-transparent
          rounded-full
          animate-spin
        `}
            />
        </div>
    );
};

export default LoadingSpinner;